import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { UserProvider } from './contexts/UserContext';

/**
 * Unregister any existing service workers to prevent 502 errors from bad service workers.
 * 
 * Service workers can intercept network requests and cache responses incorrectly,
 * causing 502 errors on API calls (especially /api/users/ endpoint during login).
 * This function ensures all service workers are unregistered and their caches cleared
 * before the app renders, preventing them from interfering with API requests.
 * 
 * This must happen before any API calls are made.
 */
async function unregisterServiceWorkers() {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) {
        const success = await registration.unregister();
        if (success) {
          console.log('Service worker unregistered successfully');
        }
      }
    } catch (error) {
      console.warn('Error unregistering service workers:', error);
    }

    // Clear all service worker caches to prevent stale cached responses
    if ('caches' in window) {
      try {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map((cacheName) => {
            console.log('Deleting cache:', cacheName);
            return caches.delete(cacheName);
          })
        );
      } catch (error) {
        console.warn('Error clearing caches:', error);
      }
    }

    // Prevent any new service workers from being registered
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      });
    });
  }
}

// Unregister service workers before rendering the app
unregisterServiceWorkers().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <UserProvider>
        <App/>
      </UserProvider>
    </React.StrictMode>
  );
});

